export const state = {
  demands: [],
  demand: {},
  totalPages: 1,
  currentPage: 1,
  demandStatuses: []
}
